export const globalApiMixin={
    methods:{
        generateApiUrl() {
			if (window.location.hostname.includes('localhost')) {
				return 'http://localhost:3010/services/training';
			} else {
				return window.location.origin + '/services/training';
			}
		},
		
    }
}